import React from "react";
import { NavLink, Route } from "react-router-dom";

const NavLinkWithChildrenFunc = ({ to, exact = false, children, ...props }) => (
  <Route path={to} exact={exact}>
    {({ match }) => (
      <NavLink to={to} exact={exact} {...props}>
        {children(match)}
      </NavLink>
    )}
  </Route>
);

export default NavLinkWithChildrenFunc;
